"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loader;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibrary = require("@site/pattern-library");
const LoadingContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LoadingContainer",
  class: "pc-lxgpku6"
});
function Loader() {
  return /*#__PURE__*/_react.default.createElement(LoadingContainer, null, /*#__PURE__*/_react.default.createElement(_patternLibrary.Spinner, {
    size: "lg",
    centerHorizontally: true
  }));
}